import { observer } from 'mobx-react';
import { FC } from 'react';
import branchEditStore from '../../store/branchEditStore';
import DeliveryConditionControls from '../DeliveryConditionControls/DeliveryConditionControls';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { Icons } from '~/assets/fonts/Icons/icons';
import { localeStore } from '~/mobx/localesStore';
import { BRANCH_DELIVERY_CONDITION, SETTINGS_DELIVERY_TYPE } from '~/types/branches';
import CustomTooltip, { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Icon from '~/view/components/Controls/Icon/Icon';

const ReduceDeliveryFeeCondition: FC = observer((): JSX.Element => {
  const onChangeStatus = (status: string | number) => {
    if (branchEditStore.editableBranch.delivery_fee_type === BRANCH_DELIVERY_CONDITION.DISABLED) {
      return;
    }
    branchEditStore.changeBranchData({ reduced_delivery_fee_type: status as BRANCH_DELIVERY_CONDITION });
  };

  const onChangeFixedValue = (value: string, key?: 'delivery_fee' | 'order_more_than') => {
    if (key === 'delivery_fee') {
      branchEditStore.changeBranchData({
        reduced: [
          {
            ...branchEditStore.editableBranch.reduced[0],
            delivery_fee: value,
          },
        ],
      });
    }
    if (key === 'order_more_than') {
      branchEditStore.changeBranchData({
        reduced: [
          {
            ...branchEditStore.editableBranch.reduced[0],
            order_more_than: value,
          },
        ],
      });
    }
  };
  const isDisable = (): string => {
    if (branchEditStore.editableBranch.delivery_fee_type === BRANCH_DELIVERY_CONDITION.DISABLED) {
      return 'opacity-50';
    }
    return '';
  };

  return (
    <div className="d-flex flex-column">
      <div className="d-flex flex-row align-items-center">
        <Text text="reduced_delivery_fee" className={isDisable()} type={TEXT.BLOCK_HEADER} />
        <CustomTooltip
          position={TOOLTIP_POSITION.FIXED}
          message={localeStore.t(isDisable().length ? 'delivery_fee_disabled' : 'reduced_delivery_fee_header_infotip')}
          wrapperClassName="ml-2"
        >
          <Icon name={Icons.Info} className="cursor-pointer color-gray2" size={18} />
        </CustomTooltip>
      </div>
      <div className={isDisable()}>
        <DeliveryConditionControls
          type={SETTINGS_DELIVERY_TYPE.REDUCED_DELIVERY_FEE}
          status={branchEditStore.editableBranch.reduced_delivery_fee_type}
          fixedValue={String('')}
          onChangeStatus={onChangeStatus}
          onChangeFixedValue={onChangeFixedValue}
        />
      </div>
    </div>
  );
});

export default ReduceDeliveryFeeCondition;
